export default __webpack_public_path__ + "static/media/platziExchangeImg_1.0084be21.webp";